import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import cx from 'classnames'

import '../../utils/stringUtils'
import appConst from '../../constant/appConst'

import hiResLogo from '../../resources/img/logo-hires.png'
import { getAlbum as getAlbumAction, getMoreTracksAlbum } from './albumActions'
import * as selectors from './albumSelectors'
import { Link } from 'react-router'
import TrackList from '../../components/tracklist/TrackList'
import redirectToApp from '../../utils/redirectToApp'
import Loader from '../../components/loader/Loader'
import { displayCdQuality, displayHiresQuality, displayReleasedDate } from '../../utils/display'

import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import * as playerSelectors from '../../components/tracklist/trackListSelectors'
import { Helmet } from 'react-helmet'
import { formatDuration } from '../../utils/formatUtils'
import ShareComponent from '../../components/share/ShareComponent'
import ReadMoreComponent from "../../components/ReadMoreComponent"
import GTMController from "../../utils/kpi/GTMController"

const fields = (shouldDisplayArtist) => {
	const displayFields = [{
		type: 'number',
		render: track => track.track_number
	},{
		type: 'name',
		render: track => `${track.title}${track.version ? ` (${track.version})` : ''}`
	}]

	if (shouldDisplayArtist) {
		displayFields.push(
			{
				type: 'artist',
				render: track => {
					let artistId = ''
					let artistName = ''

					if (track.id && track.performer) {
						artistId = track.performer.id
						artistName = track.performer.name
					}
					return (<Link to={`/artist/${artistId}`}>{artistName}</Link>)
				}
			}
		)
	}

	displayFields.push({
		type: 'time',
		render: track => formatDuration(track.duration)
	})

	return displayFields
}


class AlbumPage extends PureComponent {

	componentWillMount() {
		const { id, getAlbum } = this.props
		getAlbum(id)

		this.showMore = this.showMore.bind(this)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
	}

	componentWillReceiveProps(nextProps) {
		const { id } = this.props
		if (id !== nextProps.id) {
			this.props.clearPlayqueue()
		}
		if (nextProps.title) {
			GTMController.pushAlbumPageEvent(nextProps.id, nextProps.title, nextProps.artist.name, nextProps.genre.name)
		}
	}


	showMore() {
		const { id, trackListOffset, getMoreTracks } = this.props
		getMoreTracks(id, trackListOffset + appConst.trackListLoadStep)
	}

	render() {
		const {
			id,
			label,
			artist,
			pochette,
			title,
			nbPistes,
			hires,
			duree,
			description,
			isQobuzissime,
			orderUrl,
			shouldDisplayArtist,
			genre,
			release_date_original,
			maximum_technical_specifications,
			maximum_bit_depth,
			maximum_channel_count,
			maximum_sampling_rate
		} = this.props
		const { intl } = this.context

		let dureeAffichee
		if (duree > 3600) {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.long' },
				{ hours: `${Math.floor(duree/3600)}`, minutes: `${Math.floor((duree % 3600)/60)}` }
			)
		} else {
			dureeAffichee = intl.formatMessage(
				{ id: 'infos.duration.short' },
				{ minutes: `${Math.floor(duree/60)}`, seconds: `${duree % 60}` }
			)
		}

		const showDisplayFull = (description || '').length > appConst.descriptionMaxLength
		const infosNbPistes = intl.formatMessage({ id: 'infos.trackCount' }, { count: `${nbPistes}` })
		const infosAlbum = `${displayReleasedDate(release_date_original, intl)} - ${infosNbPistes} - ${dureeAffichee}`
		return (
			<Loader>
				<div className="page page--album">
					<Helmet>
						<title>{intl.formatMessage({ id: "title.album" }, { albumName: title, artistName: artist.name })}</title>
						<link rel="canonical" href={`https://open.qobuz.com/album/${id}`} />
					</Helmet>
					<div className="page__background page__background--album" style={{ backgroundImage: `url(${pochette})` }} />

					<div className="page__container clearfix">

						{/* HEADING BLOC */}
						<div className="heading">
							<img className="heading__cover" src={pochette} alt={title} />
							<div className={cx('heading__container', 'heading__container--album', {'heading__container--no-hires': !hires})}>
								<div className="heading__texts">
									<h1 className="heading__title">{title}</h1>
									<p className="heading__infos">
										<span className="heading__infos--text">{intl.formatMessage({ id: 'album.by' })} </span>
										<Link className="heading__infos--link" to={`/artist/${artist.id}`}>{artist.name}</Link>
										<span className="heading__infos--text"> {intl.formatMessage({ id: 'album.publishedBy' })} </span>
										{label && <span className="heading__infos--link">{label.name}</span>}
									</p>
								</div>
								<div className="heading__buttons">
									<a
										className="heading__button heading__button--album pct pct-play"
										onClick={() => {
											GTMController.pushEvent(GTMController.EVENTS.ALBUM_PLAY)
											redirectToApp('album', id)
										}}
									>
										{intl.formatMessage({ id: 'buttons.listen' })}
									</a>
									{orderUrl &&
										<a
											className="heading__button heading__button--album pct pct-buy"
											onClick={() => { GTMController.pushEvent(GTMController.EVENTS.ALBUM_BUY)}
											}
											href={`${appConst.albumOderUrl}${id}`}
											target="_blank"
										>
											{intl.formatMessage({ id: 'buttons.buy' })}
										</a>
									}
									<ShareComponent GTMCopyEvent={GTMController.EVENTS.ALBUM_SHARE}/>
								</div>

								<div className="quality">
									<p className="quality__text">{intl.formatMessage({ id: 'infos.available' })}</p>
									{hires ?
										<div  className="quality__container">
											<img
												className="quality__image"
												src={hiResLogo}
												alt={intl.formatMessage({ id: 'infos.hires' })}
												height={35}
												width={35}
											/>
											<p className="quality__text">{displayHiresQuality(maximum_technical_specifications)}</p>
										</div>
										: <div  className="quality__container">
											<span className="quality__image pct pct-disc" />
											<p className="quality__text">
												{displayCdQuality(maximum_bit_depth, maximum_sampling_rate, maximum_channel_count)}
											</p>
										</div>
									}
								</div>
							</div>
						</div>

						{/* INFOS BLOC */}
						<div className="infos">
							<h2 className="infos__title">{intl.formatMessage({ id: 'aside.title' })}</h2>
							{genre && <p className="infos__subtitle">{intl.formatMessage({ id: `genre.genre-id-${genre.id}`})}</p>}
							<p className="infos__track">
								{infosAlbum}
							</p>
							{isQobuzissime &&
								<span className="infos__reward pct pct-reward">Qobuzissime</span>
							}
							{(description && description.length > 0) &&
								<div className={cx('infos__container', { 'infos__container--long': showDisplayFull})}>
									<p
										{...{ className: 'infos__excerpt' }}
										dangerouslySetInnerHTML={{ __html: (description ? `${description}` : '').nl2br() }}
									/>
									<ReadMoreComponent id={id} type={"album"} />
								</div>
							}
						</div>

						{/* TRACKLIST BLOC */}
						<div className="tracklist">
							<h2 className="tracklist__title">{intl.formatMessage({ id: 'tracklist.title.album' })}</h2>
							<TrackList
								fields={fields(shouldDisplayArtist)}
								displayWork={true}
								listContainerClassName="tracklist__container tracklist__container--album"
								listClassName={`tracklist__tracks ${shouldDisplayArtist ? 'full' : 'full-name'}`}
								GTMPlayEvent={ GTMController.EVENTS.ALBUM_TRACK_PLAY }
								moreItemsCallback={this.showMore}
							/>
						</div>
					</div>
				</div>
			</Loader>
		)
	}

}

AlbumPage.propTypes = {
	id: PropTypes.string,
	idTrack: PropTypes.string,
	label: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	pochette: PropTypes.string,
	title: PropTypes.string,
	artist: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	nbPistes: PropTypes.number,
	hires: PropTypes.bool,
	duree: PropTypes.number,
	description: PropTypes.string,
	genre: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	release_date_original: PropTypes.string,
	maximum_bit_depth: PropTypes.number,
	maximum_channel_count: PropTypes.number,
	maximum_sampling_rate: PropTypes.number,
	maximum_technical_specifications: PropTypes.string,
	isQobuzissime: PropTypes.bool,
	orderUrl: PropTypes.string,
	trackListOffset: PropTypes.number,
	shouldDisplayArtist: PropTypes.bool,
	getAlbum: PropTypes.func,
	getMoreTracks: PropTypes.func,
}

AlbumPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	label: selectors.getLabel(state),
	pochette: selectors.getPochette(state),
	title: selectors.getTitle(state),
	artist: selectors.getArtist(state),
	nbPistes: selectors.getNbPistes(state),
	hires: selectors.isHires(state),
	duree: selectors.getDuree(state),
	description: selectors.getDescription(state),
	genre: selectors.getGenre(state),
	release_date_original: selectors.getReleasedAt(state),
	maximum_bit_depth: selectors.getMaximumBitDepth(state),
	maximum_channel_count: selectors.getMaximumChannelCount(state),
	maximum_sampling_rate: selectors.getMaximumSamplingRate(state),
	maximum_technical_specifications: selectors.getMaximumTechnicalSpecification(state),
	isQobuzissime: selectors.isQobuzissime(state),
	orderUrl: selectors.getOrderUrl(state),
	trackListOffset: playerSelectors.getTrackListOffset(state),
	shouldDisplayArtist: selectors.shouldDisplayArtist(state)
})

const actions = {
	getAlbum: getAlbumAction,
	getMoreTracks: getMoreTracksAlbum,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(AlbumPage)



// WEBPACK FOOTER //
// ./src/pages/album/AlbumPage.jsx